import React from "react";
import Button from "../../../components/ui/Button";
import Icon from "../../../components/AppIcon";
import { ModalShell, ModalHeader } from "../../../components/ui/ModalFrame";
import { MODAL_LAYER } from "../../../constants/modalLayers";
import { MODAL_DIALOG_ACTIONS_END } from "../../../constants/layoutSpacing";
import { cn } from "../../../utils/cn";
import { evaluateSignatureSendReadiness } from "../../../utils/signatureSendReadiness";

const SignatureSendChecklistModal = ({
  open,
  contract,
  onClose,
  onContinue,
}) => {
  if (!open || !contract) return null;

  const { items, ready } = evaluateSignatureSendReadiness(contract);

  return (
    <ModalShell
      zClass={MODAL_LAYER.standard}
      backdropClassName="bg-black/50"
      panelClassName="bg-card rounded-xl max-w-md w-full shadow-elevation-lg border border-border flex flex-col"
    >
      <ModalHeader
        title="Enviar para assinatura"
        onClose={onClose}
      />
      <div className="px-5 py-4 space-y-3">
        <p className="text-sm text-muted-foreground">
          {contract.name || contract.title || "Documento"}
        </p>
        <ul className="space-y-2">
          {items.map((item) => (
            <li
              key={item.id}
              className={cn(
                "flex gap-3 rounded-lg border px-3 py-2 text-sm",
                item.ok
                  ? "border-emerald-500/30 bg-emerald-500/5"
                  : "border-destructive/30 bg-destructive/5"
              )}
            >
              <Icon
                name={item.ok ? "CheckCircle2" : "AlertCircle"}
                size={18}
                className={item.ok ? "text-emerald-600 shrink-0" : "text-destructive shrink-0"}
              />
              <div>
                <p className="font-medium text-foreground">{item.label}</p>
                <p className="text-xs text-muted-foreground mt-0.5">{item.detail}</p>
              </div>
            </li>
          ))}
        </ul>
        <p className="text-xs text-muted-foreground">
          No próximo passo você posiciona signatários e campos de assinatura no PDF.
        </p>
      </div>
      <div className={cn(MODAL_DIALOG_ACTIONS_END, "px-5 py-4 border-t border-border")}>
        <Button type="button" variant="outline" onClick={onClose}>
          Cancelar
        </Button>
        <Button type="button" onClick={onContinue} disabled={!ready}>
          Continuar
        </Button>
      </div>
    </ModalShell>
  );
};

export default SignatureSendChecklistModal;
